import { ToastController, BrandVariants } from "./fable_modules/FS.FluentUI.2.5.2/Domain.fs.js";
import { Record, Union } from "./fable_modules/fable-library-js.4.24.0/Types.js";
import { record_type, tuple_type, list_type, class_type, bool_type, option_type, string_type, union_type } from "./fable_modules/fable-library-js.4.24.0/Reflection.js";
import { User_$reflection } from "./Shared/SharedModels.jsx";
import { createContext } from "./fable_modules/Feliz.2.9.0/Internal.fs.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { Toaster, createLightTheme, createDarkTheme, FluentProvider, useToastController, useId } from "@fluentui/react-components";
import { createObj } from "./fable_modules/fable-library-js.4.24.0/Util.js";
import { reactApi } from "./fable_modules/Feliz.2.9.0/Interop.fs.js";
import { singleton, append, delay, toList } from "./fable_modules/fable-library-js.4.24.0/Seq.js";
import { reactApi as reactApi_1 } from "./fable_modules/Feliz.2.9.0/Interop.fs.js";

export const iipBrands = new BrandVariants("#020404", "#101C1A", "#142E2B", "#173C37", "#184A44", "#195851", "#19675F", "#17766D", "#13867B", "#149589", "#43A297", "#62AFA5", "#7DBCB3", "#97C9C1", "#B0D6D0", "#C9E3DF");

export class ThemeType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Light", "Dark"];
    }
}

export function ThemeType_$reflection() {
    return union_type("Context.ThemeType", [], ThemeType, () => [[], []]);
}

export class ContextModel extends Record {
    constructor(User, AppVersion, NavbarOpen, ThemeType, ToastToUpdate, ToastToDismiss) {
        super();
        this.User = User;
        this.AppVersion = AppVersion;
        this.NavbarOpen = NavbarOpen;
        this.ThemeType = ThemeType;
        this.ToastToUpdate = ToastToUpdate;
        this.ToastToDismiss = ToastToDismiss;
    }
}

export function ContextModel_$reflection() {
    return record_type("Context.ContextModel", [], ContextModel, () => [["User", User_$reflection()], ["AppVersion", option_type(string_type)], ["NavbarOpen", bool_type], ["ThemeType", ThemeType_$reflection()], ["ToastToUpdate", option_type(tuple_type(class_type("Fable.React.ReactElement", undefined), list_type(string_type)))], ["ToastToDismiss", string_type]]);
}

export class ContextMsg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["UpdateToast", "DismissToast", "UpdateUser", "UpdateNavbarOpen", "UpdateThemeType"];
    }
}

export function ContextMsg_$reflection() {
    return union_type("Context.ContextMsg", [], ContextMsg, () => [[["Item", tuple_type(class_type("Fable.React.ReactElement", undefined), list_type(string_type))]], [["Item", string_type]], [["Item", User_$reflection()]], [["Item", bool_type]], [["Item", ThemeType_$reflection()]]]);
}

export function UpdateContext(model, msg) {
    switch (msg.tag) {
        case 1:
            return new ContextModel(model.User, model.AppVersion, model.NavbarOpen, model.ThemeType, model.ToastToUpdate, msg.fields[0]);
        case 2:
            return new ContextModel(msg.fields[0], model.AppVersion, model.NavbarOpen, model.ThemeType, model.ToastToUpdate, model.ToastToDismiss);
        case 3:
            return new ContextModel(model.User, model.AppVersion, msg.fields[0], model.ThemeType, model.ToastToUpdate, model.ToastToDismiss);
        case 4:
            return new ContextModel(model.User, model.AppVersion, model.NavbarOpen, msg.fields[0], model.ToastToUpdate, model.ToastToDismiss);
        default:
            return new ContextModel(model.User, model.AppVersion, model.NavbarOpen, model.ThemeType, msg.fields[0], model.ToastToDismiss);
    }
}

export const context = createContext(undefined, undefined);

export function ContextProvider(contextProviderInputProps) {
    let el_2;
    const children = contextProviderInputProps.children;
    const session = contextProviderInputProps.session;
    const toasterId = useId("toaster", undefined);
    let toastController;
    const controller = useToastController(toasterId);
    toastController = (new ToastController((tupledArg) => {
        const options_1 = createObj(tupledArg[1]);
        controller.dispatchToast(tupledArg[0], options_1);
    }, (props) => {
        controller.dismissToast(props);
    }, (props_1) => {
        controller.dismissAllToasts();
    }, (props_2) => {
        controller.updateToast(createObj(props_2));
    }, (props_3) => {
        controller.pauseToast(props_3);
    }, (props_4) => {
        controller.playToast(props_4);
    }));
    let patternInput;
    const arg_1 = new ContextModel(session.User, session.AppVersion, true, new ThemeType(0, []), undefined, "");
    patternInput = reactApi.useReducer(UpdateContext, arg_1);
    const ctx = patternInput[0];
    const dependencies = [ctx.ToastToUpdate];
    reactApi.useEffect(() => {
        const matchValue = ctx.ToastToUpdate;
        if (matchValue != null) {
            toastController.dispatchToast(matchValue);
        }
    }, dependencies);
    const dependencies_2 = [ctx.ToastToDismiss];
    reactApi.useEffect(() => {
        toastController.dismissToast(ctx.ToastToDismiss);
    }, dependencies_2);
    let child;
    const xs = [(el_2 = FluentProvider, createElement(el_2, createObj(toList(delay(() => append((ctx.ThemeType.tag === 1) ? singleton(["theme", createDarkTheme(iipBrands)]) : singleton(["theme", createLightTheme(iipBrands)]), delay(() => {
        let elems;
        return singleton((elems = toList(delay(() => append(children, delay(() => {
            let el;
            return singleton((el = Toaster, createElement(el, {
                toasterId: toasterId,
            })));
        })))), ["children", reactApi_1.Children.toArray(Array.from(elems))]));
    })))))))];
    child = react.createElement(react.Fragment, {}, ...xs);
    return reactApi.createElement(context.Provider, {
        value: [ctx, patternInput[1]],
    }, child);
}

export function useCtx() {
    return reactApi.useContext(context);
}

//# sourceMappingURL=Context.jsx.map
